import {ChessPiece} from "./chessPiece";
import {KNIGHT_BLACK, KNIGHT_WHITE} from "./svg";

export class Knight extends ChessPiece {
    name = 'knight';

    svgBlack = KNIGHT_BLACK;
    svgWhite = KNIGHT_WHITE;

    positionsUnderAttack(board) {
        let result = [
            [this.posX - 2, this.posY - 1],
            [this.posX - 2, this.posY + 1],
            [this.posX + 2, this.posY - 1],
            [this.posX + 2, this.posY + 1],
            [this.posX - 1, this.posY - 2],
            [this.posX - 1, this.posY + 2],
            [this.posX + 1, this.posY - 2],
            [this.posX + 1, this.posY + 2],
        ];
        result = result.filter(pos => {
            return pos[0] >= 0 && pos[0] < board.scaleX && pos[1] >= 0 && pos[1] < board.scaleY
        });
        return result
    }

    availablePositions(board) {
        let result = this.positionsUnderAttack(board);
        result = result.filter(pos => {
            const piece = board.getPiece(pos[0], pos[1]);
            return !piece || piece.player !== this.player
        });
        result = result.filter(pos => {
            return !this.isCheckAfterMove(board, pos)
        });
        return result;
    }

    clone() {
        const result = new Knight();
        super.clone(result);
        return result;
    }
}